var App = App || {};

App.OnlineBanking = (function ($) {
    'use strict';

    var $type = $('.onlinebanking-section #onlineBankingType'),
        $pbPanels = $('.onlinebanking-section .pb-panel'),
        $otherPanels = $('.onlinebanking-section .other-panel'),
        loginModalSettings = $('.onlinebanking-section').data('modals'),
        $loginModal = $('#loginModal');

    function init() {

        $type.change(function () {
            if (!$type.find("option[value='" + $type.val() + "']").data("form")) { //if there's no associated form
                ShowGo();
                updateGoButton();
            }
            else { //if this option has an associated form
                HideInnerTop(); //make room for the form
                $($type.val()).removeClass('d-none'); //show it
            }
        });

        $(".olb-go").on("click", function () {
            //if there's an associated olb speedbump modal active, set content (modal functionality handled in Speedbump.js)
            for (var i in loginModalSettings) {
                if (loginModalSettings[i].MappingHtmlId == $(".olb-go").data("option-id") && loginModalSettings[i].IsEnabled) {
                    $loginModal.find('.modal-title').html(loginModalSettings[i].Title);
                    $loginModal.find('.modal-body').html(loginModalSettings[i].Content);
                }
            }
        });

        $(".olb-back").on("click", function () { //set olb menu to default view
            ShowInnerTop();
            if ($type.find("option[value='" + $type.val() + "']").data("form")) {
                $type.val($type.find("option:eq(0)").val());
            }
            updateGoButton();
            $(".onlinebanking-inner-top-logintype.radio").focus();
        });

        $('.onlinebanking-section input[type=radio][name=OlbRadio]').change(function () { //personal/business form toggle
            $pbPanels.addClass('d-none');
            $($(this).val()).removeClass('d-none');
        });

        $(".olb-launch").on("click", ToggleOlb);

        $(".olb-close").on("click", CloseOlb);

        $(".onlinebankingshade").on("click", CloseOlb);

        SetupOnlineBankingPanels();
        updateGoButton();

        $(window).on("resize", ChangeOLBTopIfOpen);
        
        // Password eye-toggle functionality
        $('#togglePassword').on('click', function () {
            var passwordInput = $('#olb-personal-d1-password');
            var icon = $(this).find('i');
            if (passwordInput.attr('type') === 'password') {
                passwordInput.attr('type', 'text');
                icon.removeClass('fa-eye').addClass('fa-eye-slash');
            } else {
                passwordInput.attr('type', 'password');
                icon.removeClass('fa-eye-slash').addClass('fa-eye');
            }
        });
    }
    function updateGoButton() { //ensure olb-go button has all the proper attributes for the selected option
        $(".olb-go").data("option-id", $type.find("option[value='" + $type.val() + "']").data("option-id"));
        $(".olb-go").attr("href", $type.val());
        if ($type.find("option[value='" + $type.val() + "']").data("show-modal") == "true") {
            $(".olb-go").addClass("show-login-modal");
        }
        else {
            $(".olb-go").removeClass("show-login-modal");
        }
    }
    function ChangeOLBTopIfOpen() {
        if($(".onlinebanking.show").length > 0) {
            // when opening online banking, make sure the header height
            $(".onlinebanking").css("top", $(".headernav").height() + "px");
        }
    }
    function HideInnerTop() { //make room for the "another account" form
        $(".onlinebanking-inner-top").addClass('d-none');
        $(".olb-back").removeClass('d-none');
        $otherPanels.addClass('d-none');
        HideGo();
    }
    function ShowInnerTop() { //undo the "another account" form changes
        $(".onlinebanking-inner-top").removeClass('d-none');
        $(".olb-back").addClass('d-none');
        ShowGo();
    }
    function ShowGo() { //show go button, hide "another account" forms
        $otherPanels.addClass('d-none');
        $(".olb-type-container").removeClass("col-12").addClass("col-10");
        $(".olb-go").removeClass('d-none');
    }
    function HideGo() { //hide go button
        $(".olb-type-container").removeClass("col-10").addClass("col-12");
        $(".olb-go").attr("href", "javascript:void(0)").addClass('d-none');
    }
    function ToggleOlb() {
        if ($(".onlinebanking").hasClass("show")) {
            CloseOlb();
        } else {
            OpenOlb();
        }
    }
    function CloseOlb() {
        if ($(".onlinebanking").length) {
            $(".onlinebanking").removeClass("show");
            $(".onlinebankingshade").hide();
        } else if ($(".onlinebanking-section").length) {
            $(".onlinebanking-section").addClass("d-none");
            $(".onlinebankingshade").hide();

        }

    }
    function OpenOlb() {
        if ($(".onlinebanking").length) {
            $(".onlinebanking").addClass("show");
            $("#OlbRadioPersonal").focus();
            $(".onlinebankingshade").show();

            // when opening online banking, make sure the header height
            $(".onlinebanking").css("top", $(".headernav").height() + "px");
        }
        else if ($(".onlinebanking-section").length) {
            $(".onlinebanking-section").removeClass("d-none");
            $(".onlinebankingshade").show();
        }
    }

    function SetupOnlineBankingPanels() {
        $.each(loginModalSettings, function (index, loginTypeSettings) {
            if (loginTypeSettings.IsEnabled) {
                var $loginTypeContainer = $('.onlinebanking-section #' + loginTypeSettings.MappingHtmlId);
                var $parentForm = $loginTypeContainer.find('form');
                var $loginFormButton = $loginTypeContainer.find('.olb-submit');

                $("#onlineBankingType option").each(function (index) {
                    if (loginTypeSettings.MappingHtmlId == $(this).data("option-id")) { //if this modal has an associated olb drop-down option
                        $(this).data("show-modal", "true"); //true value is used to show modal when olb-go button is clicked
                    }
                });

                if ($parentForm.length > 0) {
                    // Prevent immediate submission and wait until modal's continue button is pressed to submit the form.
                    $loginFormButton.on('click', function (e) {
                        if ($parentForm[0].checkValidity()) {
                            $loginModal.find('.modal-title').html(loginTypeSettings.Title);
                            $loginModal.find('.modal-body').html(loginTypeSettings.Content);
                            $loginModal.find('#loginModalSubmit')
                                .attr('href', 'javascript:void(0);')
                                .attr('target', '')
                                .off('click.loginmodalsubmit')
                                .on('click.loginmodalsubmit', function () {
                                    $parentForm.submit(); // Submit the form when Modal Continue button is pressed.
                                    $loginModal.modal('hide');
                                });

                            $loginModal.modal('show');
                        } else {
                            return true;  //submit invalid form to display browsers' native validity error
                        }

                        return false; // Prevent immediate submission.
                    });
                }
                else {
                    /* For standalong anchors, decorate and let the Speedbump app control the functionality as 
                     * Speedbump logic still needs to be supported. */
                    $loginFormButton
                        .data('loginmodaltitle', loginTypeSettings.Title)
                        .data('loginmodalcontent', loginTypeSettings.Content)
                        .addClass('show-login-modal');
                }
            }
        });

    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.OnlineBanking.init();
});